import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import AccountRoute from "./home";
import LogoutRoute from "./logout";


const basepath = `/account`;

export function Content() {
  return (
    <Switch>
      <Route path={`${basepath}/logout`} component={LogoutRoute} />
      <Route path={`${basepath}/`} component={AccountRoute} />
    </Switch>
  );
}

export const Sidebar = () => (
  <>

  </>
);

export const Indice = () => (
  <>
    <BreadcrumbItem>
      <Link to={`${basepath}`}>Account</Link>
    </BreadcrumbItem>
    <Switch>

    </Switch>
  </>
);
